module.exports = __webpack_public_path__ + "img/188.caf65f4d.jpg";